<template>
  <div class="product-ccard-container">
    <div class="title">
      <span>VIP会员设置</span>
    </div>
    <el-form ref="dataForm" :model="dataForm" :rules="dataRules" label-width="90px" size="small">
    <div class="form">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="会员名称" prop="name">
            <el-input v-model="dataForm.name" placeholder="请输入会员名称" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="年费" prop="price">
            <el-input v-model="dataForm.price" type="number" placeholder="请输入价格" clearable style="width: 150px; margin-right: 20px"></el-input>
            <el-button type="text" @click="handleChangePriceLog" size="small">查看价格变动</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="适用门店" prop="storeIds">
            <el-select size="small" v-model="dataForm.storeIds" placeholder="请选择适用门店" multiple filterable
                       clearable style="width: 100%">
              <el-option-group
                v-for="group in stores"
                :key="group.label"
                :label="group.label">
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="有效期" prop="durationDays">
            购买后
            <el-input type="number" v-model="dataForm.durationDays" :min="1"
                      style="width: 100px; margin: 0 10px;"></el-input>天
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="显示折扣" prop="showDiscount">
            <el-input v-model="dataForm.showDiscount" type="number" placeholder="请输入显示折扣" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
    <div class="title" style="margin-top: 30px;">
      <span>权益设置</span>
    </div>
    <div class="title2">
      <span>首单减免设置</span>
    </div>
    <div class="other">
      <el-form-item label="减免金额" prop="firstOrderDiscount">
        <el-input v-model="dataForm.firstOrderDiscount" type="number" placeholder="请输入价格" size="small" clearable style="width: 200px;  margin-right: 20px"/>
      </el-form-item>
      <el-form-item label="适用项目" prop="firstOrderService">
        <el-select size="small" v-model="dataForm.firstOrderService" placeholder="请选择适用项目" multiple filterable
                   clearable style="width: 500px">
          <el-option
              v-for="item in service"
              :key="item.id"
              :label="item.title"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </div>
    <br/>
    <div class="title2">
      <span>优惠项目设置</span>
    </div>
    <div class="other">
      <el-table
        :data="serviceGroup"
        :header-cell-style="{background:'#F2F2F4'}"
        style="width: 100%">
        <el-table-column prop="groupName" align="center" label="分类"></el-table-column>
        <el-table-column prop="service" align="center" label="项目">
          <template #default="{ row }">
            <el-select size="small" v-model="row.serviceIds" placeholder="请选择适用项目" multiple filterable
                       clearable style="width: 100%">
                <el-option
                    v-for="item in serviceTypeGroup[row.groupId] || []"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">
                </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="store" align="center" label="门店">
          <template #default="{ row }">
            <el-select size="small" v-model="row.storeIds" placeholder="请选择适用门店" multiple filterable
                       clearable style="width: 100%">
              <el-option-group
                  v-for="group in stores"
                  :key="group.label"
                  :label="group.label">
                <el-option
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-option-group>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="discount" align="center" label="折扣">
          <template #default="{ row }">
            <el-input v-model="row.discount" type="number" size="small"></el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <br/>
    <div class="title2">
      <span>生日券设置</span>
    </div>
    <div class="other flex">
      <el-form-item label="券码ID" prop="couponId">
        <el-input v-model="dataForm.couponId" placeholder="请输入券ID" size="small" clearable style="width: 200px; "/>
      </el-form-item>
    </div>
    <br/>
    <div class="title2">
      <span>体验卡设置</span>
    </div>
    <div class="other">
        <el-form-item label="有效期" prop="trialCardDuration">
          <el-input v-model="dataForm.trialCardDuration" type="number" placeholder="请输入有效期" size="small" clearable style="width: 200px"/>
          <span style="margin-left: 10px">天</span>
        </el-form-item>
        <el-form-item label="数量" prop="trialCardNum">
          <el-input v-model="dataForm.trialCardNum" type="number" placeholder="请输入数量" size="small" clearable style="width: 200px"/>
          <span style="margin-left: 10px">张</span>
        </el-form-item>
    </div>
    </el-form>
    <div class="footer">
      <el-button size="small" @click="handleCancel">返 回</el-button>
      <el-button size="small" type="primary" @click="handleSave">保 存</el-button>
    </div>
    <br/>
    <br/>
    <!-- 增加项目 -->
    <priceLog ref="priceLogRef"/>
  </div>
</template>

<script>
import priceLog from "./changePriceLog.vue";

export default {
  components: {priceLog},
  data() {
    return {
      id: '',
      dataForm: {
        id: '',
        name: '',
        price: '',
        storeIds: [],
        durationDays: '',
        firstOrderDiscount: '',
        firstOrderService: [],
        trialCardDuration: '',
        trialCardNum: '',
        service: [],
        showDiscount: '',
        status: 1,
      },
      dataRules: {
        name: [{required: true, message: '请输入会员名称', trigger: 'blur'}],
        price: [{required: true, message: '请输入价格', trigger: 'blur'}],
        storeIds: [{required: true, message: '请选择可用门店', trigger: 'blur'}],
        durationDays: [{required: true, message: '请输入有效期', trigger: 'blur'}],
        couponId: [{required: true, message: '请输入券ID', trigger: 'blur'}],
        firstOrderDiscount: [{required: true, message: '请输入价格', trigger: 'blur'}],
        firstOrderService: [{required: true, message: '请选择适用项目', trigger: 'blur'}],
        trialCardDuration: [{required: true, message: '请输入体验卡有效期', trigger: 'blur'}],
        trialCardNum: [{required: true, message: '请输入体验卡数量', trigger: 'blur'}],
        showDiscount: [{required: true, message: '请输入显示折扣', trigger: 'blur'}],
      },
      /*门店列表*/
      stores: [],
      /*服务列表*/
      service:[],
      serviceTypes: ['剪发服务', '烫染服务', '洗吹服务', '护理服务', '造型', '迷你烫', '健康染发', '健康烫发', '洗吹护理', '美甲'],
      serviceGroup: [
        {
          'groupId': 0,
          'vipId': 1,
          'groupName': '剪发服务',
          'serviceIds': [],
          'storeIds': [],
          'discount': ''
        },
        {
          'groupId': 1,
          'vipId': 1,
          'groupName': '烫染服务',
          'serviceIds': [],
          'storeIds': [],
          'discount': ''
        },
        {
          'groupId': 2,
          'vipId': 1,
          'groupName': '洗吹服务',
          'serviceIds': [],
          'storeIds': [],
          'discount': ''
        },
        {
          'groupId': 3,
          'vipId': 1,
          'groupName': '护理服务',
          'serviceIds': [],
          'storeIds': [],
          'discount': ''
        },
        {
          'groupId': 4,
          'vipId': 1,
          'groupName': '造型',
          'serviceIds': [],
          'storeIds': [],
          'discount': ''
        },
        {
          'groupId': 5,
          'vipId': 1,
          'groupName': '迷你烫',
          'serviceIds': [],
          'storeIds': [],
          'discount': ''
        },
        {
          'groupId': 6,
          'vipId': 1,
          'groupName': '健康染发',
          'serviceIds': [],
          'storeIds': [],
          'discount': ''
        },
        {
          'groupId': 7,
          'vipId': 1,
          'groupName': '健康烫发',
          'serviceIds': [],
          'storeIds': [],
          'discount': ''
        },
        {
          'groupId': 8,
          'vipId': 1,
          'groupName': '洗吹护理',
          'serviceIds': [],
          'storeIds': [],
          'discount': ''
        }
        ,
        {
          'groupId': 9,
          'vipId': 1,
          'groupName': '美甲',
          'serviceIds': [],
          'storeIds': [],
          'discount': ''
        }
      ],
      serviceTypeGroup: [],
      /*价格变动*/
      dialogVisible: false,
      dialogTitle: '价格变动',
      changePriceLog: []
    }
  },
  created() {
    this.fetchStore()
    this.fetchService()

    const id = this.$route.query.id;
    if (id) {
      this.fetchDetail(id)
    }
  },
  methods: {
    fetchStore() {
      this.$http.get("store/list").then(({data}) => {
        let storesBusiness = []
        let storesEnd = []
        data.data.forEach(ele => {
          const val = {value: ele.id, label: ele.title};
          if (ele.businessType === 1) {
            storesEnd.push(val) //结业门店
          } else {
            storesBusiness.push(val) //营业门店
          }
        })
        this.stores = [
          {
            label: '营业门店',
            options: storesBusiness
          },
          {
            label: '结业门店',
            options: storesEnd
          },
        ]
      })
    },
    fetchService() {
      this.$http.get("dhaircut/option?state=1").then(({data}) => {
        this.service = data.data;

        // 初始化serviceTypeGroup
        let serviceTypeGroup = {};

        data.data.forEach(ele => {
          // 如果 serviceTypeGroup 中还没有这个 type 的键，则初始化一个空数组
          if (!serviceTypeGroup[ele.type]) {
            serviceTypeGroup[ele.type] = [];
          }

          // 将当前元素添加到对应 type 的数组中
          serviceTypeGroup[ele.type].push({
            id: ele.id,
            title: ele.title,
            // 假设你还需要其他字段，可以在这里添加
          });
        });

        // 更新组件的数据属性
        this.serviceTypeGroup = serviceTypeGroup;

        console.log('serviceTypeGroup', serviceTypeGroup)
      });
    },
    fetchDetail(id) {
      this.$http.get(`uVip/${id}`).then(({data}) => {
        if (data.code !== 200) {
          this.$alert(data.msg, {
            confirmButtonText: '确定',
          });
          return
        }
        if (data.data != null) {
          this.dataForm = data.data
          // 获取 service 数据列表
          const serviceList = data.data.service || [];

          // 遍历当前前端的 serviceGroup
          this.serviceGroup.forEach(group => {
            // 在接口数据中查找 groupId 匹配的项
            const matchedService = serviceList.find(item => item.groupId === group.groupId);

            if (matchedService) {
              // 设置 storeIds 和 serviceIds（可选：默认为空数组）
              group.storeIds = matchedService.storeIds || [];
              group.serviceIds = matchedService.serviceIds || [];
              group.discount = matchedService.discount || ''
            }
          });
        }
      })
    },
    handleCancel() {
      this.$router.push({path: '/uvip'})
    },
    /**
     * 保存
     */
    handleSave() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.serviceGroup.length === 0) {
            this.$message.error("请设置适配项目")
            return
          }
          let params = this.dataForm
          params.service = this.serviceGroup
          this.$http.post("uVip", JSON.stringify(params)).then(({data}) => {
            if (data.code === 200) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.handleCancel()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      });
    },
    /**
     * 查看价格变动记录
     */
    handleChangePriceLog() {
      this.$nextTick(() => {
        this.$refs.priceLogRef.show(this.id)
      })
    }
  }
}
</script>
<style scoped lang="less">
.title {
  span {
    margin-right: 10px;
    font-weight: bold;
  }

  font-size: 1.17em;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.title2 {
  span {
    margin-right: 10px;
  }
  color: #606266;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}


.item-label {
  width: 78px;
  color: #606266;
  text-align: right;
  font-size: 14px;
  padding: 0 12px 0 0;
  white-space: nowrap;
}

.other {
  display: flex;
  justify-content: left;

  .item-box {
    width: 973px;
  }

  .add {
    width: 100%;
    clear: both;
    text-align: center;
    margin-top: 20px;
  }
}

.flex {
  display: flex;
  align-items: center;
}

::v-deep .el-dialog__body {
  padding-top: 10px;
}

.btn {
  font-size: 12px;
  padding: 0 5px;
}

.input {
  .el-input {
    width: 200px;
  }
}

.add-coupon {
  .el-input {
    width: 200px;
    margin-left: 10px;
  }

  .el-button {
    margin-left: 10px;
  }

  display: flex;
  align-items: center;
}

.coupon-list {
  margin-top: 20px;

  .el-tag {
    margin-right: 10px;
  }
}

.footer {
  margin-top: 80px;
  padding: 10px 0;
  background-color: #F2F6FC;
  width: 100%;
  text-align: center;
}
</style>
